export default {
	createEditandoObject: (defaultValues = false) => {
		return {
			editando: {
				pais: defaultValues,
				estado: defaultValues,
				cidade: defaultValues,
			},
		}
	},
	createCamposLocalidade(item, tipo, nivel = 1) {
		if (tipo === 'P') {
			if (nivel >= 1) {
				item.designativo_partida = ''
				item.lat_partida = ''
				item.lng_partida = ''
				item.fuso_partida = ''
				item.decolagem_utc_partida = ''
				item.rotaer_partida = []
			}
			if (nivel >= 2) {
				item.cidade_partida = ''
				item.id_cidade_partida = ''
				item.lista_cidades_partida = []
			}
			if (nivel === 3) {
				item.estado_partida = ''
				item.id_estado_partida = ''
				item.estado_partida = []
			}
		} else { // if (tipo == 'D')
			if (nivel >= 1) {
				item.designativo_destino = ''
				item.lat_destino = ''
				item.lng_destino = ''
				item.fuso_destino = ''
				item.rotaer_destino = []
			}
			if (nivel >= 2) {
				item.cidade_destino = ''
				item.id_cidade_destino = ''
				item.lista_cidades_destino = []
			}
			if (nivel === 3) {
				item.estado_destino = ''
				item.id_estado_destino = ''
				item.estado_destino = []
			}
		}
		return item;
	}
}
